<template>
	<div class="flex space-x-4">
		<ui-select-group
			class="flex-grow"
			v-model="localStatus"
			:form="{}"
			field="status"
			type="select"
			label="Status"
			:no-label="true"
			:options="threadStatusOptions"
			:required="true"
		></ui-select-group>

		<ui-button v-bind:disabled="buttonDisabled" v-on:click="postUpdate()">
			{{ __("Save") }}
		</ui-button>
	</div>
</template>

<script>
let options = require("../../cropOptions");
export default {
	props: {
		thread: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			threadStatusOptions: options.threadStatusOptions,
			buttonLock: false,
			localStatus: this.thread.status,
			endpoint: window.baseUrl + "/api/thread/" + this.thread.id + "/status",
		};
	},
	computed: {
		buttonDisabled() {
			return this.buttonLock || this.thread.status == this.localStatus;
		},
	},
	methods: {
		async postUpdate() {
			this.buttonLock = true;
			let req = await axios.post(this.endpoint, {
				data: {
					status: this.localStatus,
				},
			});
			this.buttonLock = false;
			let updatedThread = req.data.data;
			this.$bus.$emit("thread-update", updatedThread);
			this.$emit("done");
		},
	},
};
</script>
